/** Public legal links shown on auth screens (terms & privacy). */
export const AUTH_DOCS = {
  doc_1: 'https://mentorme.kz/',
  doc_2: 'https://mentorme.kz/',
};
